import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import draggable from "vuedraggable";

export default {
  components: { draggable },
  props: {
    isInFiles: Boolean,
  },
  data() {
    return {
      users: this.$store.state.user,
      rootfolders: [],
      isLoading: true,
      listview: false,
    };
  },
  created() {
    EventBus.$on("welcome-root-folders--request-access", () => {
      this.isLoading = false;
      this.requestAccess();
    });

    EventBus.$on("roots", (id) => {
      this.isLoading = true;
      this.$axios
        .get(baseUrl + "/roots", {
          responseType: "json",
        })
        .then((response) => {
          let items = response.data;
          this.setRootFolders(items);

          this.isLoading = false;

          if (this.rootfolders.length == 0) {
            EventBus.$emit("nospaces");
          } else {
            EventBus.$emit("yespaces");
          }
        })
        .catch((e) => {
          this.isLoading = false;
        });
    });
    EventBus.$on("login", (id) => {
      this.isLoading = true;
      this.$axios
        .get(baseUrl + "/roots", {
          responseType: "json",
        })
        .then((response) => {
          let items = response.data;
          this.users = this.$store.state.user;
          this.setRootFolders(items);

          this.isLoading = false;

          EventBus.$emit("yespaces");
          if (this.rootfolders.length == 0) {
            EventBus.$emit("nospaces");
          }
        })
        .catch((e) => {
          this.isLoading = false;
        });
    });
  },
  beforeMount() {
    this.$axios
      .get(baseUrl + "/roots", {
        responseType: "json",
      })
      .then((response) => {
        this.isLoading = false;

        let items = response.data;
        this.setRootFolders(items);
        if (this.rootfolders.length === 0) {
          EventBus.$emit("nospaces");
        }
      })
      .catch((e) => {
        this.isLoading = false;
      });
  },
  methods: {
    redirect() {
      if (!this.$store.state.isMobile) {
        //is desktop so go to welcome
        this.$router.replace(`/${this.$store.state.company}`);
      } else {
        //go to spaces
        this.$router.replace(`/${this.$store.state.company}/spaces`);
      }
    },
    updateOrder() {
      if (this.users) {
        let orders = {};
        Object.entries(this.rootfolders).forEach(function (item, index) {
          orders[item[1].id] = index;
        });
        let formData = new FormData();
        formData.append("folders", JSON.stringify(orders));
        this.$axios
          .post(baseUrl + "/rootsorder", formData)
          .then((response) => {});
      }
    },
    requestAccess() {
      EventBus.$emit("requestAccessButton", true);
      EventBus.$emit(`home-right-content-open`);
    },
    makePrivate(id) {
      let formData = new FormData();
      formData.append("folder", id);
      this.$axios
        .post(baseUrl + "/folderprivate", formData)
        .then((response) => {});
    },

    setRootFolders(items) {
      this.rootfolders = [];
      if (this.users != null && this.users.rights["my-space"] === 0) {
        for (let item in items) {
          if (!items[item].id.includes("myspace")) {
            this.rootfolders.push(items[item]);
          }
        }
      } else {
        this.rootfolders = items;
      }
    },
  },
};
